import React from "react";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Contact.css";

function Contact() {
  return (
    <section className="contact-section text-center" id="contact">
      <div className="container">
        <h2 className="section-title">Hast du Fragen?</h2>
        <p className="contact-text">Kontaktiere uns und wir helfen dir gerne weiter!</p>
        <Link to="/contact" className="btn btn-primary btn-lg">
          <i className="fas fa-envelope"></i> Kontakt aufnehmen
        </Link>
      </div>
    </section>
  );
}

export default Contact;
